import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { Divider, Image, SideNavContainer, StyledList } from './SideNav.Styles';

import BarChartIcon from '@mui/icons-material/BarChart';
import ForumIcon from '@mui/icons-material/Forum';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import QuizIcon from '@mui/icons-material/Quiz';
import SettingsIcon from '@mui/icons-material/Settings';
import SummarizeIcon from '@mui/icons-material/Summarize';
import logo from '../../assets/logo.svg';
import ListItem from '../ListItem/ListItem';

export default function SideNav() {
  const { t } = useTranslation();

  return (
    <SideNavContainer className="sidenav-container">
      <Image src={logo} alt="Logo" />
      <StyledList>
        <ListItem
          item={t('dashboard')}
          href={'dashboard'}
          Icon={HomeOutlinedIcon}
        />
        <ListItem
          item={t('questionnaires')}
          href={'questionnaires'}
          Icon={BarChartIcon}
        />
        <ListItem
          item={t('messages')}
          href={'messages'}
          Icon={MailOutlineIcon}
        />
        <ListItem item={t('questions')} href={'questions'} Icon={QuizIcon} />
        <ListItem
          item={t('resources')}
          href={'resources'}
          Icon={MenuBookOutlinedIcon}
        />
        <ListItem
          item={t('employees')}
          href={'employees'}
          Icon={PersonOutlineOutlinedIcon}
        />
        <ListItem item={t('reports')} href={'reports'} Icon={SummarizeIcon} />
        <ListItem item={t('aiprompts')} href={'aiprompts'} Icon={ForumIcon} />
        <ListItem item={t('settings')} href={'settings'} Icon={SettingsIcon} />
      </StyledList>
      <Divider />
      <LanguageSelector />
    </SideNavContainer>
  );
}
